'use client';

import { Toaster } from 'sonner';

export function AppToaster() {
  return <Toaster position="top-center" theme="dark" richColors />;
}
